import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ACTIVE_SURFACE_MUTED } from "@/shared/theme";

interface InfoControlProps {
  label: string;
  description: string;
  inline?: boolean;
  inverted?: boolean;
  interactive?: boolean;
}

/** Standard Chessla control for short, beginner-friendly metric explanations. */
export const InfoControl = ({
  label,
  description,
  inline = false,
  inverted = false,
  interactive = true,
}: InfoControlProps) => (
  <Tooltip title={description}>
    {interactive ? (
      <IconButton
        size="small"
        aria-label={`What ${label} means`}
        sx={{
          width: 18,
          height: 18,
          p: 0,
          flexShrink: 0,
          display: inline ? "inline-flex" : undefined,
          verticalAlign: inline ? "middle" : undefined,
          transform: inline ? "translateY(-1px)" : undefined,
          color: inverted ? ACTIVE_SURFACE_MUTED : "text.secondary",
          cursor: "default",
          "&:hover, &:focus-visible": {
            color: inverted ? "background.default" : "primary.main",
            bgcolor: "transparent",
          },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 13 }} />
      </IconButton>
    ) : (
      <Box
        component="span"
        aria-label={`What ${label} means`}
        sx={{
          width: 18,
          height: 18,
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: inverted ? ACTIVE_SURFACE_MUTED : "text.secondary",
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 13 }} />
      </Box>
    )}
  </Tooltip>
);
